import lazy from '@fatso83/retry-dynamic-import/react-lazy';
import { Navigate } from 'react-router';
import { useHomeRedirectPath } from 'hooks/useHomeRedirectPath';
import useUser from 'hooks/useUser';

const Landing = lazy(() => import('screens/Auth/Landing'));

const HomeRedirect = () => {
  const { user } = useUser();
  const homePath = useHomeRedirectPath();

  if (!user?.status) {
    return <Landing />;
  }
  return <Navigate to={homePath} replace />;
};

export default HomeRedirect;
